import { render, staticRenderFns } from "./ContentCounters.vue?vue&type=template&id=358a55c1&scoped=true&"
import script from "./ContentCounters.vue?vue&type=script&lang=js&"
export * from "./ContentCounters.vue?vue&type=script&lang=js&"
import style0 from "./ContentCounters.vue?vue&type=style&index=0&id=358a55c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358a55c1",
  null
  
)

export default component.exports